window.ShowroomAppointmentModal = {
  bindModalEvents() {
    if (this.modalEventsBound) return;

    this.modalEventsBound = true;

    this.modalCloseButtons?.forEach((button) => {
      button.addEventListener("click", () => {
        this.closeModal();
      });
    });

    this.modal?.addEventListener("click", (event) => {
      const closeButton = event.target.closest("[data-showroom-modal-close]");
      const backdrop = event.target.closest("[data-showroom-modal-backdrop]");

      if (closeButton || backdrop) {
        this.closeModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (
        event.key === "Escape" &&
        this.modal?.classList.contains("is-open")
      ) {
        this.closeModal();
      }
    });
  },

  openModal() {
    if (!this.modal) return;

    this.lockBodyScroll();

    this.modal.setAttribute("aria-hidden", "false");

    window.requestAnimationFrame(() => {
      this.modal.classList.add("is-open");
      document.body.classList.add("showroom-modal-open");

      this.hideTechnicalFields?.();
    });

    window.setTimeout(() => {
      this.hideTechnicalFields?.();
    }, 500);
  },

  closeModal() {
    if (!this.modal) return;

    this.modal.classList.remove("is-open");
    this.modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("showroom-modal-open");

    window.setTimeout(() => {
      this.unlockBodyScroll();
    }, 220);
  },

  lockBodyScroll() {
    if (this.bodyScrollLocked) return;

    this.bodyScrollLocked = true;
    this.scrollY = window.scrollY || document.documentElement.scrollTop;

    document.body.style.position = "fixed";
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflowY = "scroll";
  },

  unlockBodyScroll() {
    if (!this.bodyScrollLocked) return;

    const scrollY = this.scrollY || 0;

    this.bodyScrollLocked = false;

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflowY = "";

    window.scrollTo(0, scrollY);
  },
};